import { render, staticRenderFns } from "./Businessenquiry.vue?vue&type=template&id=3b1545c0&scoped=true&"
import script from "./Businessenquiry.vue?vue&type=script&lang=js&"
export * from "./Businessenquiry.vue?vue&type=script&lang=js&"
import style0 from "./Businessenquiry.vue?vue&type=style&index=0&id=3b1545c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1545c0",
  null
  
)

export default component.exports